import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import VueFire from 'vuefire'
import firebase from 'firebase'
import Login from '@/components/login/Login'



const NotFoundComponent = resolve => {
    require.ensure(['@/components/NotFoundComponent'], () => {
        resolve(require('@/components/NotFoundComponent'));
    });
};
const OffersNew = resolve => {
    require.ensure(['@/components/offers/OffersNew'], () => {
        resolve(require('@/components/offers/OffersNew'));
    });
};
const Setup = resolve => {
    require.ensure(['@/components/setup/Setup'], () => {
        resolve(require('@/components/setup/Setup'));
    });
};
const Offers = resolve => {
    require.ensure(['@/components/offers/Offers'], () => {
        resolve(require('@/components/offers/Offers'));
    }, 'offers');
};
const OffersList = resolve => {
    require.ensure(['@/components/offers/OffersList'], () => {
        resolve(require('@/components/offers/OffersList'));
    }, 'offers');
};
const OffersDetail = resolve => {
    require.ensure(['@/components/offers/OffersDetail'], () => {
        resolve(require('@/components/offers/OffersDetail'));
    }, 'offers');
};
const OffersEdit = resolve => {
    require.ensure(['@/components/offers/OffersEdit'], () => {
        resolve(require('@/components/offers/OffersEdit'));
    }, 'offers');
};

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/setup',
            component: Setup,
            name: 'setup',
            beforeEnter: (to, from, next) => {
                firebase.auth().onAuthStateChanged(function(user) {
                    if (user) {
                        next();
                    } else {
                        //alert('You Must log in first');
                        next({
                            name: 'login'
                        });
                    }
                });
            },
        },
        {
            path: '/offers',
            component: Offers,
            beforeEnter: (to, from, next) => {
                firebase.auth().onAuthStateChanged(function(user) {
                    if (user) {
                        next();
                    } else {
                        //alert('You Must log in first');
                        next({
                            name: 'login'
                        });
                    }
                });
            },
            children: [{
                    path: '',
                    component: OffersList,
                    name: 'offersList'
                },
                {
                    path: 'new',
                    component: OffersNew,
                    name: 'offersNew',
                    props: true
                },
                
                {
                    path: ':id',
                    component: OffersDetail,
                    name: 'offersDetail',
                    props: true
                },
                {
                    path: ':id/edit',
                    component: OffersEdit,
                    name: 'offersEdit'
                }
            ]
        },
        {
            path: '*',
            component: NotFoundComponent
        }
    ],

    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js